//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
let d=[[[0,"ControlDirection",1,0],[0,"InitializeFromDriveLeadAngle",1,0],[0,"InitializeFromDriveMaxAngle",1,0],[0,"InitializeFromDriveStepSize",1,0],[0,"InitializeFromDriveTiltAngle",1,0],[0,"InterpolationMethod",1,0],[0,"TurnInputMode",1,0],[0,"TurnInterpolationMethod",1,0]],[[[],"ResetToDefault",{},0,0],[["index"],"GetPoint",{R_:{point:"Point"}},1,0],[[],"GetTotalNumberOfPoints",{R_:{totalNumber:''}},0,0]],[]];
SPLM.CAM.ToolAxisInterpolate = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.ToolAxisInterpolate";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.ToolAxisInterpolate.InterpolateTypes = Object.freeze({
    "Vector" : "Vector", "AngleToPart" : "AngleToPart", "AngleToDrive" : "AngleToDrive"});

SPLM.CAM.ToolAxisInterpolate.InterpolationMethodTypes = Object.freeze({
    "Linear" : "Linear", "CubicSpline" : "CubicSpline", "Smooth" : "Smooth", "AbsoluteInitFromDrive" : "AbsoluteInitFromDrive"});

SPLM.CAM.ToolAxisInterpolate.ControlDirectionTypes = Object.freeze({
    "Uandv" : "Uandv", "U" : "U", "V" : "V"});

SPLM.CAM.ToolAxisInterpolate.TurnInterpolationMethodTypes = Object.freeze({
    "Absolute" : "Absolute", "Relative" : "Relative"});

SPLM.CAM.ToolAxisInterpolate.TurnInputModeTypes = Object.freeze({
    "HolderAngleFromPart" : "HolderAngleFromPart", "ClearanceAngle" : "ClearanceAngle", "CuttingAngle" : "CuttingAngle"});

export default SPLM;